"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

function useWeekDisabled(_ref) {
  var disabledDate = _ref.disabledDate,
      locale = _ref.locale,
      generateConfig = _ref.generateConfig;
  var disabledCache = React.useMemo(function () {
    return new Map();
  }, [disabledDate]);

  function disabledWeekDate(date) {
    var weekStr = generateConfig.locale.format(locale.locale, date, 'YYYY-WW');

    if (!disabledCache.has(weekStr)) {
      var disabled = false;

      var checkDisabled = function checkDisabled(offset) {
        for (var i = 0; i < 7; i += 1) {
          var currentDate = generateConfig.addDate(date, i * offset);
          var currentWeekStr = generateConfig.locale.format(locale.locale, currentDate, 'YYYY-WW');

          if (currentWeekStr !== weekStr) {
            break;
          }

          if (disabledDate(currentDate)) {
            disabled = true;
            break;
          }
        }
      };

      checkDisabled(1);
      checkDisabled(-1);
      disabledCache.set(weekStr, disabled);
    }

    return disabledCache.get(weekStr);
  }

  return [disabledWeekDate];
}

exports["default"] = useWeekDisabled;